
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      appointmentBGI: require("@/assets/img/booking-image.png"),
    };
  },
});
